export const TITLE_DATA_MOCK = {
  storeName: "TestStoreName",
  themeName: "TestTheme",
};
